import { isEmpty } from 'lodash';
import { observable, makeObservable, action, runInAction } from 'mobx';
import { isDeniedAction } from 'Utils/common';

class PermissionStore {
  constructor(api) {
    this.api = api;
    this.deniedPatterns = [];
    this.permissionLoaded = false;

    makeObservable(this, {
      getAclSettings: action,
      deniedPatterns: observable,
      permissionLoaded: observable,
    });
  }

  getAclSettings() {
    this.api.get('acl/setting/denied').then((response) => {
      if (response.status === 200) {
        runInAction(() => {
          this.permissionLoaded = true;
          this.deniedPatterns = response.data;
        });
      }
    });
  }

  isDenied(patterns) {
    if (isEmpty(patterns) || isEmpty(this.deniedPatterns)) return false;

    return isDeniedAction(patterns, this.deniedPatterns);
  }
}

export default PermissionStore;
